import "./Footer.css"


const Footer = () => {
  return (
    <footer className="footer">
      <p className="footer__text">A donatmarton.com portfolio project</p>
      <p className="footer__text">See source & roadmap on <a className="footer__link" href="https://github.com/donatmarton/budget" rel="noreferrer" target="_blank">GitHub/donatmarton</a></p>
    </footer>
  )
}

export default Footer;
